export const GET_WORK_TYPES = 'app/Containers/Header/GET_WORK_TYPES'
export const SET_WORK_TYPES = 'app/Containers/Header/SET_WORK_TYPES'



